import React from 'react'
import { Wrapper, Title, Image, WrapperContent, Paragraph, ArrowRight, ButtonTheme, Link } from './StyledVyberArticle'
import utmLinkGenerator from '../../utils/UTMLinkGenerator'

const Article = ({ article, utmParams, imageSize, handleGaEvent }) => {
  const {
    guid,
    title,
    description,
    link,
    images: {
      [imageSize]: imageSrc
    }
  } = article

  const onClick = (event) => {
    return handleGaEvent(event, {
      id: guid,
      position: 1,
      url: link,
      title
    })
  }

  const linkWithUtm = utmLinkGenerator.createLink(link, { ...utmParams, utmTerm: 'position-1' })

  return (
    <Link href={linkWithUtm} onClick={onClick}>
      <Wrapper>
        <Image src={imageSrc} />
        <WrapperContent>
          <Title>{title}</Title>
          <Paragraph>{description}</Paragraph>
          <ButtonTheme>Přejít na téma <ArrowRight /></ButtonTheme>
        </WrapperContent>
      </Wrapper>
    </Link>
  )
}

export default Article
